import { DOM } from '@antv/l7-utils';
export var tileVectorParser = ['mvt', 'geojsonvt', 'testTile'];
/**
 * 判断当前图层是否是瓦片图层
 * @param layer
 * @returns
 */

export function isTileGroup(layer) {
  var source = layer.getSource();
  return tileVectorParser.includes(source.parser.type);
}
export function getContainerSize(container) {
  if (container.getContext) {
    return {
      width: container.width / DOM.DPR,
      height: container.height / DOM.DPR
    };
  } else {
    return container.getBoundingClientRect();
  }
}